import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { CountryDefinition } from '../../../model/v3/people';

@Injectable({
  providedIn: 'root',
})
export class PublicV3RestService {
  constructor(private http: HttpClient) {}

  private baseUrl(path: string): string {
    return `${environment.eventsApiBase}/public${path}`;
  }

  listCountries(): Observable<CountryDefinition[]> {
    return this.http.get<CountryDefinition[]>(this.baseUrl('/countries'));
  }
}
